import React, { useState } from "react";
import axios from "axios";
import { Clock, ArrowRight, Rocket } from "lucide-react";
import "./HeroSectionFinal.css";
import { generateApiKey } from "../../../helpers/common.helpers";
import FeedbackForm from "./Navbar/FeedbackForm"; // Import your FeedbackForm component
import { updateUserFeedbackCountServices } from "../../../services/users.services";
import { useMutation } from "@tanstack/react-query";

const Button = ({ children, className = "", style, ...props }) => {
  return (
    <button
      className={`inline-flex items-center justify-center transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${className}`}
      style={style}
      {...props}
    >
      {children}
    </button>
  );
};

const HeroSectionFinal = () => {
  const [loading, setLoading] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [shouldCallApiAfterFeedback, setShouldCallApiAfterFeedback] = useState(false);
  const isLocked = localStorage.getItem("status") !== "active";

  const fetchthinficurl = async () => {
    setLoading(true);
    try {
      const response = await axios({
        method: "post",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "page-index": generateApiKey(),
        },
        url: `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/dashboardhomepage/fetch_thinkific_url`,
        data: {
          email: localStorage.getItem("email"),
          firstname: localStorage.getItem("username"),
          lastname: localStorage.getItem("lastname"),
        },
      });
      setLoading(false);
      let url = response.data;
      if (Array.isArray(url)) {
        url = url[0]?.url || url[0]?.sso_url || url[0]?.link || url[0];
      } else if (typeof url === 'object' && url !== null) {
        url = url.url || url.sso_url || url.link;
      }
      
      if (typeof url === 'string' && url.startsWith('http')) {
        window.open(url, "_blank");
      } else {
        console.error("Invalid Thinkific URL format:", response.data);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching Thinkific URL:", error);
    }
  };

  const { mutate: updateUserFeedBackCount } = useMutation({
    mutationFn: ({ userId }) =>
      updateUserFeedbackCountServices({ userId }),
    onSuccess: (data) => {
      // queryClient.invalidateQueries(["acknowledgment-status"]);
      // setOpen(false);
      console.log(data)
      localStorage.setItem("feedback_count", data.feedback_count);
    },
    onError: (error) => {
      console.error("Error updating acknowledgment status:", error);
    }
  });


  const checkEmailInGoogleSheets = async () => {
    try {
      // const feedbackCount = localStorage.getItem("dashboardFeedBackCount") || 0
      const backendFeedbackCount = Number(localStorage.getItem("feedback_count")) || 0
      const dashboardFeedBackCount = Number(localStorage.getItem("dashboardFeedBackCount")) || 0;
      const dashboardFeedbackStatus = Number(localStorage.getItem("dashboardFeedbackStatus")) || 0;
      // const userEmail = localStorage.getItem("email");
      // updateUserFeedBackCount({ userId: localStorage.getItem("user_id") });
      // const res = await fetch(
      //   "https://script.google.com/macros/s/AKfycbw101VUPZ28IEdK-X6fZFLukOn4Lrkp5Av0Zus5aiVurzgFBqvunskYNQBQhfOWhs2P/exec"
      // );
      // const data = await res.json();
      // const emailRecord = data.emailData.find(item => item.email === userEmail);


      if (dashboardFeedbackStatus === 1) {
        return true
      } else if (dashboardFeedBackCount > 1) {
        return true
      } else if (backendFeedbackCount >= 3) {
        return true
      } else {
        return false
      }


      // if (feedbackCount > 3 || backendFeedbackCount > 3) {
      //   return true
      // } else ifelse if (feedbackCount <= 3) {

      //   if (emailRecord) {
      //     return true;
      //   } else {

      //     return false;
      //   }
      // } else {
      //   return true
      // }

    } catch (error) {
      console.error("Error checking email in Google Sheets:", error);
      // If there's an error checking, assume email doesn't exist and show feedback
      return false;
    }

  };

  const handleContinueLearning = async () => {

    const dashboardFeedBackCount = localStorage.getItem("dashboardFeedBackCount") || 0;
    localStorage.setItem("dashboardFeedBackCount", Number(dashboardFeedBackCount) == 0 ? 1 : Number(dashboardFeedBackCount) + 1);
    // Check if email exists in Google Sheets
    setLoading(true)
    const emailExists = await checkEmailInGoogleSheets();
    setLoading(false)
    if (emailExists) {
      // Email exists, directly call the API
      await fetchthinficurl();
    } else {
      // Email doesn't exist, show feedback modal first
      // const feedbackCount = localStorage.getItem("dashboardFeedBackCount") || 0
      // console.log(feedbackCount)
      // if (feedbackCount > 3) {
      //   await fetchthinficurl()
      //   setShowFeedbackModal(false);
      // } else {
      // localStorage.setItem("dashboardFeedBackCount", Number(feedbackCount) + 1)
      updateUserFeedBackCount({ userId: localStorage.getItem("user_id") });
      setShouldCallApiAfterFeedback(true)
      setShowFeedbackModal(true);
      // }
      // setShowFeedbackModal(true);
    }
  };

  const handleFeedbackClose = async () => {
    setShowFeedbackModal(false);

    // If we need to call the API after feedback, do it now
    if (shouldCallApiAfterFeedback) {
      setShouldCallApiAfterFeedback(false);
      await fetchthinficurl();
    }
  };

  return (
    <>
      <div
        className="min-w-0 overflow-hidden rounded-xl border border-gray-200 mb-8"
        style={{
          background:
            "linear-gradient(135deg, #1E40AF 0%, #2563EB 50%, #3B82F6 100%)",
          borderRadius: "12px",
          padding: "30px 20px",
          boxShadow: "0 10px 30px rgba(30,64,175,0.2)",
        }}
      >
        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between">
          <div className="flex-1  text-center md:text-left pr-0 mb-6 md:pr-8">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-2 md:mb-6">
              Welcome back, {localStorage.getItem("username")}!
            </h1>
            <p className="text-sm md:text-xl text-blue-100">
              Everything you need to move forward is <span className=" italic ">right here</span>.
            </p>
          </div>
          <div className="flex flex-col gap-4  items-center">
            <Button
              onClick={() => {
                const element = document.getElementById("cod");
                element?.scrollIntoView({ behavior: "smooth" });
              }}
              className={`h-12 ${!isLocked ? "w-full" : "w-[300px]"} px-6  rounded-full font-bold transition-all duration-300 hover:scale-105 group relative overflow-hidden`}
              style={{
                background: "rgba(255,255,255,0.1)",
                color: "white",
                border: "1px solid rgba(255,255,255,0.2)",
                backdropFilter: "blur(10px)",
              }}
            >
              <div className="absolute inset-0 bg-white/10 translate-x-[-100%] group-hover:translate-x-0 transition-transform duration-500" />
              <Clock className="w-4 h-4 mr-2 relative z-10" />
              <span className="relative z-10 text-[16px]">Challenge of the Day</span>
            </Button>
            {!isLocked ? (
              <Button
                id="tour-continue-learning"
                onClick={handleContinueLearning}
                disabled={loading}
                className="h-12 w-full px-10 font-bold text-[16px] transition-all duration-500 group relative overflow-hidden floating-card rounded-full"
                style={{
                  background: "linear-gradient(135deg, #FFFFFF 0%, #F1F5F9 100%)",
                  color: "#1E40AF",
                  transformStyle: "preserve-3d",
                  perspective: "1000px",
                }}
              >
                <div
                  className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-2 translate-x-2"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(30,64,175,0.2) 0%, rgba(59,130,246,0.1) 100%)",
                    filter: "blur(12px)",
                    zIndex: -1,
                  }}
                />
                <div className="absolute opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <div className="rocket-trail trail-1"></div>
                  <div className="rocket-trail trail-2"></div>
                  <div className="rocket-trail trail-3"></div>
                </div>
                <div className="absolute inset-0 overflow-hidden rounded-full">
                  <div className="orbital-particle particle-1"></div>
                  <div className="orbital-particle particle-2"></div>
                  <div className="orbital-particle particle-3"></div>
                  <div className="orbital-particle particle-4"></div>
                </div>


                <div className="relative z-10 flex items-center">
                  <Rocket className="w-6 h-6 mr-4 transition-all duration-300 rocket-launch" />
                  <span className="tracking-wide transition-all duration-300 group-hover:text-blue-700">
                    {loading ? "Please wait while we load your course" : "Continue Learning"}
                  </span>
                  {/* <ArrowRight className="w-6 h-6 ml-4 transition-all duration-500 group-hover:translate-x-3 group-hover:scale-110" /> */}
                </div>
              </Button>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      {/* Feedback Modal */}
      {showFeedbackModal && (
        <FeedbackForm onClose={handleFeedbackClose} />
      )}
    </>
  );
};

export default HeroSectionFinal;
